export default __webpack_public_path__ + "static/media/resource.38f7addf.png";